<template>
  <!-- eslint-disable max-len -->
  <div class="text-center mt-64">
    <h3 class="h3 mb-32">Uh oh, this sitter does not exist.</h3>
    <Button size="large" value="Go to my Sittercity" href="/account/seekers/dashboard" />
  </div>
  <!-- eslint-enable max-len -->
</template>

<script lang="ts">
import Button from '../../components/button/Button.vue';

export default {
  name: 'NoSitterError',
  components: { Button },
};
</script>
